import React from "react";
import {
  Box,
  Backdrop,
  CircularProgress,
  Stack,
  Typography,
  Button,
  Container,
  Grid2,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import useInfo from "../../hooks/getInfo";
import DrawIcon from "@mui/icons-material/Draw";
const Inicio = () => {
  const { encabezado, congresos, error, loading } = useInfo();

  return (
    <Container
      maxWidth
      style={{
        backgroundColor: "rgb(203, 203, 203)",
      }}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!congresos && !encabezado}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {congresos && encabezado && (
        <Stack spacing={3} pt={5}>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, md: 4, lg: 4 }}
              style={{ textAlign: "center" }}
            >
              <img src={encabezado.arte} style={{ width: "100%" }} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 8, lg: 8 }} alignContent="center">
              <Typography
                variant="h4"
                style={{ color: "black", textAlign: "center" }}
              >
                {encabezado.nombre}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={10}>
            {congresos.map((actual) => (
              <Grid2
                size={{ xs: 12, md: 4, lg: 4 }}
                style={{ textAlign: "center" }}
                alignContent="center"
              >
                <Card
                  style={{ backgroundColor: "transparent", color: "black" }}
                >
                  <CardActionArea
                    href={process.env.REACT_APP_URL_INSCRIPCION + actual.hash}
                    target="_blank"
                  >
                    <CardMedia
                      component="img"
                      image={actual.imagen}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {actual.Nombre}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "black" }}>
                        {actual.Fecha_Inicio}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions style={{ textAlign: "center" }}>
                    <Button
                      style={{ color: "black", backgroundColor: "transparent" }}
                      size="small"
                      color="primary"
                      href={process.env.REACT_APP_URL_INSCRIPCION + actual.hash}
                      target="_blank"
                      startIcon={<DrawIcon />}
                    >
                      CLICK PARA INSCRIBIRSE
                    </Button>
                  </CardActions>
                </Card>{" "}
              </Grid2>
            ))}
          </Grid2>
        </Stack>
      )}
    </Container>
  );
};

export default Inicio;
